// src/pages/organization/OrganizationLayout.jsx
import { Outlet } from 'react-router-dom';
import { AppSidebar } from '../../components/AppSidebar/AppSidebar';
import OrganizationTabs from '../../components/Tabs/OrganizationTabs';
import '../settings/settings.scss';

export default function OrganizationLayout() {
  return (
    <div className="layout">
      <AppSidebar />
      <div className="layout__content">
        <header className="settings-header">
          <h1 className="settings-header__title">Organization</h1>
          <p className="settings-header__subtitle">Company settings & reference data</p>
        </header>

        <OrganizationTabs />

        <section className="settings-body">
          <Outlet />
        </section>
      </div>
    </div>
  );
}
